/* ===== Tanluxe PDP interactions ===== */
(function(){
  var root = document.getElementById('fadewell-pdp');
  if(!root) return;

  /* marquee: duplicate track for seamless loop */
  root.querySelectorAll('.marquee-track').forEach(function(t){ t.innerHTML += t.innerHTML; });

  /* announcement bar — rotate messages + genuine weekly countdown to Sunday 23:59:59 */
  (function(){
    var ticker = root.querySelector('#tlx-ticker');
    var cd = document.getElementById('tlx-countdown');
    if(cd){
      var pad = function(n){ return (n<10?'0':'') + n; };
      var tick = function(){
        var now = new Date();
        // "Ends at midnight" — count down to the next 00:00; resets daily. Always < 24h.
        var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0,0,0,0);
        var s = Math.max(0, Math.floor((end - now)/1000));
        var h = Math.floor(s/3600);  s -= h*3600;
        var m = Math.floor(s/60);    s -= m*60;
        cd.textContent = pad(h)+'h ' + pad(m)+'m ' + pad(s)+'s';
      };
      tick(); setInterval(tick, 1000);
    }
    if(ticker){
      var msgs = ticker.querySelectorAll('.tick-msg');
      if(msgs.length > 1){
        var i = 0;
        setInterval(function(){
          msgs[i].classList.remove('active');
          i = (i + 1) % msgs.length;
          msgs[i].classList.add('active');
        }, 3800);
      }
    }
  })();

  /* gallery — thumbs + mobile swipe */
  (function(){
    var gallery = root.querySelector('#tlx-gallery');
    var slides = root.querySelectorAll('#tlx-gallery .slide');
    var thumbs = root.querySelectorAll('#tlx-thumbs .thumb');
    if(!slides.length) return;
    var cur = 0;
    function go(idx){
      var n = slides.length;
      cur = ((idx % n) + n) % n;                 // wrap around
      slides.forEach(function(s,i){ s.classList.toggle('active', i===cur); });
      thumbs.forEach(function(x,i){ x.classList.toggle('active', i===cur); });
    }
    thumbs.forEach(function(t, idx){ t.addEventListener('click', function(){ go(idx); }); });
    /* swipe (mobile) */
    if(gallery){
      var x0=null, y0=null;
      gallery.addEventListener('touchstart', function(e){ var t=e.changedTouches[0]; x0=t.clientX; y0=t.clientY; }, {passive:true});
      gallery.addEventListener('touchend', function(e){
        if(x0===null) return;
        var t=e.changedTouches[0], dx=t.clientX-x0, dy=t.clientY-y0;
        if(Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){ go(cur + (dx<0 ? 1 : -1)); }
        x0=null; y0=null;
      }, {passive:true});
    }
  })();

  /* offer tiers + working add-to-cart */
  function fmt(n){ return '$' + Number(n).toFixed(2); }
  root.querySelectorAll('.offer').forEach(function(offer){
    var tiers = offer.querySelectorAll('.tier2, .t2-onetime');
    var btn = offer.querySelector('.tlx-atc');
    tiers.forEach(function(t){
      t.addEventListener('click', function(){
        tiers.forEach(function(x){ x.classList.remove('selected'); var r=x.querySelector('input'); if(r) r.checked=false; });
        t.classList.add('selected');
        var r = t.querySelector('input'); if(r) r.checked = true;
        if(btn){
          var was = t.dataset.was ? ' <s>' + t.dataset.was + '</s>' : '';
          // data-price is pre-formatted per market via Liquid | money (e.g. "£27.99"); use verbatim so
          // the CTA localizes on tier-switch. Do NOT re-prepend a "$" (that dollarized £/A$ markets).
          btn.innerHTML = (t.dataset.cta || 'Add to Cart') + ' &mdash; ' + t.dataset.price + was;
          btn.dataset.vid = t.dataset.vid;
          btn.dataset.qty = t.dataset.qty || '1';
          btn.dataset.plan = t.dataset.plan || '';
          btn.dataset.drawer = t.dataset.drawer || '';
        }
      });
    });
    if(btn){
      btn.addEventListener('click', function(){
        var vid = (btn.dataset.vid || '').replace('gid://shopify/ProductVariant/','');
        var qty = parseInt(btn.dataset.qty || '1', 10);
        var plan = btn.dataset.plan ? Number(btn.dataset.plan) : null;
        var drawer = btn.dataset.drawer === 'true';
        if(!vid){ window.location.href = '/cart'; return; }
        btn.disabled = true; var label = btn.innerHTML; btn.innerHTML = 'Adding...';
        var done = function(){ btn.disabled = false; btn.innerHTML = label; };
        if(window.tanluxeAddToCart){
          // tanluxeAddToCart persists the cart (add -> re-read /cart.js -> refresh UI)
          // and OWNS the redirect: 1-bottle + one-time open the drawer; 2/3-bottle go
          // to /checkout. Never redirect straight off add.js here.
          window.tanluxeAddToCart({ id: Number(vid), quantity: qty, sellingPlan: plan, openDrawer: drawer })
            .then(function(){ done(); })   // only reached on the drawer route; checkout navigates away
            .catch(function(){ done(); });
        } else {
          // Defensive fallback (the bridge module should always be present).
          // Still persist-before-redirect: add -> re-read /cart.js -> only then navigate.
          var item = { id: Number(vid), quantity: qty };
          if(plan){ item.selling_plan = plan; }
          fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ items:[ item ] }) })
            .then(function(res){ return res.json(); })
            .then(function(addResp){
              if(addResp && addResp.status){ done(); return; }
              return fetch('/cart.js', { headers:{ Accept:'application/json' } })
                .then(function(r){ return r.json(); })
                .then(function(){ window.location.href = drawer ? '/cart' : '/checkout'; });
            })
            .catch(function(){ done(); });
        }
      });
    }
  });

  /* accordions (buy box + FAQ) */
  root.querySelectorAll('.q').forEach(function(q){
    var btn=q.querySelector('button'), a=q.querySelector('.a');
    if(!btn||!a) return;
    if(q.classList.contains('open')){ a.style.maxHeight=a.scrollHeight+'px'; }
    btn.addEventListener('click', function(){
      var group=q.closest('.acc, .faq-list') || root;
      var open=q.classList.contains('open');
      group.querySelectorAll('.q').forEach(function(x){ x.classList.remove('open'); var xa=x.querySelector('.a'); if(xa) xa.style.maxHeight=null; });
      if(!open){ q.classList.add('open'); a.style.maxHeight=a.scrollHeight+'px'; }
    });
  });

  /* deep-dive expandable cards */
  root.querySelectorAll('.deep-card').forEach(function(c){
    var head=c.querySelector('.deep-head'), body=c.querySelector('.deep-body');
    if(!head||!body) return;
    head.addEventListener('click', function(){
      var open=c.classList.contains('open');
      root.querySelectorAll('.deep-card').forEach(function(x){ x.classList.remove('open'); var xb=x.querySelector('.deep-body'); if(xb) xb.style.maxHeight=null; });
      if(!open){ c.classList.add('open'); body.style.maxHeight=body.scrollHeight+'px'; }
    });
  });

  /* carousels */
  function initCar(carId, prevId, nextId){
    var car=document.getElementById(carId); if(!car) return;
    var prev=document.getElementById(prevId), next=document.getElementById(nextId);
    var step=function(){ var s=car.children[0]; return s ? s.offsetWidth+22 : 350; };
    if(prev) prev.addEventListener('click', function(){ car.scrollBy({left:-step(),behavior:'smooth'}); });
    if(next) next.addEventListener('click', function(){ car.scrollBy({left:step(),behavior:'smooth'}); });
  }
  initCar('tlx-ingcar','tlx-ingprev','tlx-ingnext');
  initCar('tlx-rscar','tlx-rsprev','tlx-rsnext');

  /* review wall — load more */
  (function(){
    var btn = document.getElementById('tlx-wallbtn');
    var more = document.getElementById('tlx-wallmore');
    if(btn && more){
      btn.addEventListener('click', function(){
        more.classList.add('open');
        btn.style.display = 'none';
      });
    }
  })();

  /* journey timeline reveals */
  (function(){
    function check(){
      var vh=window.innerHeight;
      var list=root.querySelector('.jr-list');
      if(list && !list.classList.contains('vis') && list.getBoundingClientRect().top < vh*0.82){ list.classList.add('vis'); }
      root.querySelectorAll('.jr-stage:not(.vis)').forEach(function(s){
        if(s.getBoundingClientRect().top < vh*0.88) s.classList.add('vis');
      });
    }
    window.addEventListener('scroll', check, {passive:true});
    window.addEventListener('resize', check);
    check();
  })();
})();
